import Phone from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import PropTypes from 'prop-types';
import React from 'react';
import { getCountryCodeByCountryAndCurrency } from '../utils/intl';
import WithShop from '../hoc/WithShop';
import config from '../../config';

const CountryCodePhoneInput = ({ value, shop, onChange, ...props }) => (
  <Phone
    {...props}
    value={value}
    country={(!value && getCountryCodeByCountryAndCurrency(shop)) || ''}
    international={false}
    countryOptions={['US', 'CA', 'GB', '...']}
    onChange={val => onChange(val || '')}
    flagsPath="https://flagicons.lipis.dev/flags/4x3/"
  />
);

CountryCodePhoneInput.propTypes = {
  shop: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

CountryCodePhoneInput.defaultProps = {
  currency: config.defaultCurrency,
  value: null,
  shop: {},
};

export default WithShop(CountryCodePhoneInput);



// WEBPACK FOOTER //
// ./src/app/components/PhoneInput.jsx